import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
  RoutesRecognized,
} from "@angular/router";
import { ErrorHandlingService } from "src/app/Services/errorHandling.service";
import { SharingDataService } from "src/app/Services/sharing-data.service";
import { TranslateResourceDefinitionPipe } from "src/app/shared/pipes/translateResourceDefinition.pipe";
import { TranslateTextPipe } from "src/app/shared/pipes/translateText.pipe";
import { containDigitValidator } from 'src/app/template/customValidators/containDigitValidator';
import { containLowerCaseValidator } from 'src/app/template/customValidators/containLowerCaseValidator';
import { nonAlphaNumericCharactersValidator } from 'src/app/template/customValidators/nonAlphaNumericCharactersValidator';
import { uniqueCharactersValidator } from 'src/app/template/customValidators/uniqueCharactersValidator';
import { UserService } from "../../user.service";

@Component({
  selector: "app-gipActivateAccount",
  templateUrl: "./gipActivateAccount.component.html",
  styleUrls: ["./gipActivateAccount.component.css"],
})
export class GipActivateAccountComponent implements OnInit {
  @Output() public isActivateFalse = new EventEmitter();
  constructor(
    private userService: UserService,
    private errorHandlingService: ErrorHandlingService,
    private route: ActivatedRoute,
    private router: Router,
    private translateText: TranslateTextPipe,
    private shareData: SharingDataService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe
  ) { }

  formular = [
    {
      formControlName: "PasswordModelNew",
      required: true,
      password: true,
      newRow: true,
      type: "password",
    },
    {
      formControlName: "PasswordModelConfirm",
      required: true,
      confirmPassword: true,
      newRow: true,
      type: "password",
      function: "comparePassword",
    },
    {
      formControlName: "btn_SavePassword",
      button: true,
      type: "submit",
      newRow: true,
      function: "btn_SavePassword",
  },
  ];

  isLoading = false;
  resourceDefinition;
  gipDefault;
  nonAlphaNumberic;
  minLength = 0;
  passwordValidators;
  uniqueChars;

  modelInput;

  @Input() hash;

  ngOnInit(): void {
    this.isLoading = true;

    this.shareData.currentResourceDefinition.subscribe(
      (data) => (this.resourceDefinition = data)
    );

    this.shareData.currentGipDefault.subscribe(
      (data) => (this.gipDefault = data)
    );

    this.initialize();
    this.checkHashdata();
  }

  action(action) {
    this[action]();
  }

  initialize() {
    this.modelInput = new FormGroup({
      PasswordModelNew: new FormControl(),
      PasswordModelConfirm: new FormControl(),
    });

    this.nonAlphaNumberic = this.translateText.transform("NONALPHACHARNUM", this.gipDefault, "GIP_NAME", "GIP_VALUE");
    this.minLength = +this.translateText.transform("MINPWDLENGTH", this.gipDefault, "GIP_NAME", "GIP_VALUE");

    this.passwordValidators= [Validators.required,Validators.minLength(this.minLength), Validators.maxLength(128), nonAlphaNumericCharactersValidator(this.nonAlphaNumberic)];

    this.translateText.transform("PWDREQUIRELOWERCASE", this.gipDefault, "GIP_NAME", "GIP_VALUE") == "true" ? this.passwordValidators.push(containLowerCaseValidator) : null;
    this.translateText.transform("PWDREQUIREUPPERCASE", this.gipDefault, "GIP_NAME", "GIP_VALUE") == "true" ? this.passwordValidators.push(containLowerCaseValidator) : null;
    this.translateText.transform("PWDREQUIREDIGIT", this.gipDefault, "GIP_NAME", "GIP_VALUE") == "true" ? this.passwordValidators.push(containDigitValidator) : null;
    this.uniqueChars = +this.translateText.transform("MINPWDLENGTH", this.gipDefault, "GIP_NAME", "GIP_VALUE");    

    if(this.uniqueChars > 0){
      this.passwordValidators.push(uniqueCharactersValidator(this.uniqueChars))
    }

    this.modelInput.controls.PasswordModelNew.setValidators(this.passwordValidators)
  }

  comparePassword() {
    if (
      this.modelInput.controls.PasswordModelConfirm.errors &&
      this.modelInput.controls.PasswordModelConfirm.errors.required
    ) {
    } else if (
      this.modelInput.value.PasswordModelNew ==
      this.modelInput.value.PasswordModelConfirm &&
      this.modelInput.value.PasswordModelNew != "" &&
      this.modelInput.value.PasswordModelConfirm != ""
    ) {
      this.modelInput.controls.PasswordModelConfirm.setErrors(null);
      return true;
    } else {
      this.modelInput.controls.PasswordModelConfirm.setErrors({
        comparePassword: true,
      });
      return false;
    }
  }

  checkHashdata() {
    this.userService.getNonOData([`portal/gethashdata?hash=${this.hash}`], (any) => this.handleHashData(any));
  }

  handleHashData(data: any) {
    if(data[0].status == 400){
      this.errorHandlingService.showError(this.translateResourceDefinition.transform('PortalTechnicalFail', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined)
      this.router.navigate(["home"]);
      this.isActivateFalse.emit();
    } else if (data[0].status == 409){
      this.errorHandlingService.showError(this.translateResourceDefinition.transform('ErrUserPassLink', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined)
      this.router.navigate(["home"]);
      this.isActivateFalse.emit();
    }
    else if (data) {
      this.isLoading = false;
    }
  }

  btn_SavePassword() {
    if (this.modelInput.status === "VALID") {
      this.isLoading = true;
      var model = {
        password: this.modelInput.value.PasswordModelNew,
        hash: this.hash,
      };
      this.userService.postData(
        `portal/activateaccount`,
        model,
        (response: Response) => {
          // this.handleSubmitSuccessResponse(response);
          this.router.navigate(['']);
          this.isActivateFalse.emit();
        },
        (response: Response) => this.handleSubmitErrorResponse(response)
      );
    }
  }

  handleSubmitSuccessResponse(response: any) {
    this.isLoading = false;
    this.errorHandlingService.showSuccess();

    this.router.navigate([`/home`]);

  }

  handleSubmitErrorResponse(response: Response) {
    if (response.status == 409) {
      var errorMessage = this.translateResourceDefinition.transform(
        "ErrUserPassLink",
        this.resourceDefinition,
        "KEY_NAME",
        "LONG_TEXT",
        "Common"
      );
      this.errorHandlingService.showError(errorMessage);
    } else {
      this.errorHandlingService.showError();
    }

    this.isLoading = false;
    this.router.navigate([`/`]);
  }
}
